import React from 'react'
import { Button, Overlay } from '@wmgtech/legato'
import FilterSelectionPill from 'modulesCommon/Filters/components/FilterSelection/FilterSelectionPill'

import { FilterContainerProps } from './Filter.props'

import styles from './FilterContainer.module.scss'

export function FilterContainer <T>({
  children,
  title = 'Filters',
  onClear,
  isClearDisabled,
  selected = [],
  totalTitle,
  triggerProps = {}
}: FilterContainerProps<T>) {
  const selectionTitle = isClearDisabled ? 'Showing' : 'Your filter selection resulted in'

  return (
    <div className={styles.container}>
      <div className={styles.pills}>
        {totalTitle && <span className={styles.totalTitle}>{selectionTitle} {totalTitle}</span>}
        {selected.map((pill) =>
          <FilterSelectionPill
            key={`${pill.key}${pill.label}`}
            pillName={pill.label}
            onReset={() => onClear(pill.key, pill.label)}
          />
        )}
      </div>
      <Overlay
        placement="bottom-end"
        className={styles.overlay}
        trigger={
          <Button
            data-edit-mode
            icon="filter-list"
            colorType="secondary-black"
            containerStyle={isClearDisabled ? 'outline' : 'solid'}
            className={styles.overlayBtn}
            {...triggerProps}
          />
        }
      >
        <div className={styles.content}>
          <h3 className={styles.header}>
            {title}
            <Button
              label="Clear"
              className={styles.headerBtn}
              colorType="secondary-black"
              containerStyle="link"
              size="xs"
              icon="undo"
              onClick={() => onClear()}
              disabled={isClearDisabled}
            />
          </h3>
          <>
            {children}
          </>
        </div>
      </Overlay>
    </div>
  )
}
